<template>
  <div class="player">
    <i v-if="!playMusic" class="el-icon-video-play fa-2x pointer" @click="play"></i>
    <i v-else class="el-icon-video-pause fa-2x pointer" @click="pause"></i>
    <div :ref="`waveform-${track.id}`" class="player__waveform"></div>
    <div class="player__duration">
      {{ duration }} / {{ parseSongLength}}
    </div>
  </div>

</template>

<script>
import axios from '@/plugins/axios'

export default {
  data() {
    return {
      waveformData: null,
      wavesurfer: null,
      playMusic: false,
      duration: '00:00',
      songInterval:null
    }
  },

  props: {
    track: { type: Object, required: true }
  },

  methods: {
    play() {
      this.playMusic = true
      this.wavesurfer.play()

      this.songInterval = setInterval(() => {
        if (this.duration === this.parseSongLength) clearInterval(this.songInterval)
        else {
          let currentTime = Math.round(this.wavesurfer.getCurrentTime())
          let minutes = Math.floor(currentTime / 60)
          let seconds = currentTime - (minutes * 60)

          this.duration = (minutes < 10 ? `0${minutes}` : minutes) + ":" + (seconds < 10 ? `0${seconds}` : seconds)
        }
      }, 1000)
    },

    pause() {
      this.playMusic = false
      this.wavesurfer.pause()
      clearInterval(this.songInterval)
    },

    makeWaveformUrl() {
      let streamUrl = (this.track.filename_slug + '.mp3');

      let waveform_parts = streamUrl.split("/");
      let f = waveform_parts.pop();

      let fParts = f.split(".");
      fParts.pop();

      return "WFJ_" + fParts.join(".")
    },

    formatTime(surferTime) {
      let now = new Date()
      now.setSeconds(surferTime)

      return now.toTimeString().replace(/.*(\d{2}:\d{2}).*/, "$1")
    }
  },

  computed: {
    parseSongLength() {
      return this.track.song_length.split(':').slice(1).join(':')
    }
  },

  created() {
    const vm = this

    axios.apiBasic
      .get(`tracks/${this.track.id}/waveform/${this.makeWaveformUrl()}/0`)
      .then(async ({ data }) => {

        let streamUrl = vm.track.filename_slug + '.mp3'
        if (data.data.refresh === 1) streamUrl = data.data.file + '.mp3'

        const WaveSurfer = (await import('wavesurfer.js')).default;

        this.wavesurfer = WaveSurfer.create({
          container: vm.$refs['waveform-' + vm.track.id] ,
          waveColor: "#B9B9B9",
          progressColor: "#0E003A",
          height: 28,
          cursorWidth: 0,
          barWidth: 1.5,
          barGap: 2,
          barRadius: 3,
          autoCenter: true,
          responsive: true,
          backend: 'MediaElement'
        })

        const waveformObj = JSON.parse(data.data.data)

        await this.wavesurfer.load(
            `${process.env.VUE_APP_STORAGE_URL}streams/2248/${streamUrl}`, waveformObj.data
        )
      })
  }
}
</script>

<style scoped lang="scss">
.player {
  display: flex;
  align-items: center;
  margin-top: 10px;

  &__waveform {
    width: 60%;
  }

  &__duration {
    width: 30%;
    font-size: 10px;
    font-weight: bold;
    margin-left: 0.5rem;
    line-height: 15px;
  }

  i {
    width: 10%;
    margin-right: 0.5rem;
    flex-shrink: 0;
  }
}
</style>